import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import baseUrl from '../api/utils';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CompanyLicenses = () => {
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const token = sessionStorage.getItem("token");

  const [mode, setMode] = useState("SAAS"); // "SAAS" | "VPS"
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (selectedMode) => {
    setLoading(true);
    try {
      const endpoint =
        selectedMode === "SAAS"
          ? `${baseUrl}/api/v2/license/saas-companies`
          : `${baseUrl}/api/v2/license/vps-installations`;

      const response = await axios.get(endpoint, {
        headers: { Authorization: token }
      });

      if (response.status === 200) {
        setRows(response.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/unauthorized");
      } else {
        MySwal.fire('Error', 'Failed to load company license data', 'error');
        console.error('Error fetching company licenses:', error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(mode);
  }, [mode]);

  const handleModeChange = (e) => {
    setMode(e.target.value);
  };

  const formatDate = (value) => (value ? value : "-");
  const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "-");

  return (
    <div>
      <div className="page-header"></div>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className='card-header'>
              <div className="tableheader2">
                <h4>Company Licenses</h4>
                <select
                  className="selectstyle btn btn-success text-left"
                  value={mode}
                  onChange={handleModeChange}
                >
                  <option className='bg-light text-dark' value="SAAS">SaaS Companies</option>
                  <option className='bg-light text-dark' value="VPS">VPS Companies</option>
                </select>
              </div>
            </div>
            <div className='card-body'>
              <div className="table-container">
                <table className="table table-hover table-bordered table-sm">
                  <thead className='thead-dark'>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Company</th>
                      <th scope="col">Company Name</th>
                      <th scope="col">Status</th>
                      <th scope="col">Start Date</th>
                      <th scope="col">Expiry Date</th>
                      {mode === "VPS" && <th scope="col">Last Check-In</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={mode === "VPS" ? 7 : 6} className='text-center py-3'>Loading...</td>
                      </tr>
                    ) : rows.length === 0 ? (
                      <tr>
                        <td colSpan={mode === "VPS" ? 7 : 6} className='text-center py-3'>
                          No {mode === "SAAS" ? "SaaS" : "VPS"} companies found
                        </td>
                      </tr>
                    ) : (
                      rows.map((row, index) => (
                        <tr key={row.company}>
                          <th scope="row">{index + 1}</th>
                          <td className='py-2'>{row.company}</td>
                          <td className='py-2'>{row.companyName}</td>
                          <td className='py-2'>
                            {row.licenseStatus === "ACTIVE" ? (
                              <div className='Activeuser'><i className="fa-solid fa-circle pr-3"></i>Active</div>
                            ) : (
                              <div className='InActiveuser'><i className="fa-solid fa-circle pr-3"></i>{row.licenseStatus}</div>
                            )}
                          </td>
                          <td className='py-2'>{formatDate(row.startDate)}</td>
                          <td className='py-2'>{formatDate(row.expiryDate)}</td>
                          {mode === "VPS" && <td className='py-2'>{formatDateTime(row.lastCheckIn)}</td>}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyLicenses